export class Branch {
    /**Branch id */
    public id: number = -1;

    /**Branch Name */
    public name: string = null;

    /**Branch geographical location */
    public location: string = null;

    /**Branch GLN - Global Location Number */
    public gln: string = null;

    /**Branch creator client username */
    public creatorClientUsername: string = null;

    public deleted: boolean = false;

    public parse(obj: any) {
        if (obj.Id != null) this.id = obj.Id;
        if (obj.Name) this.name = obj.Name;
        if (obj.Location) this.location = obj.Location;
        if (obj.GLN) this.gln = obj.GLN;
        if (obj.CreatorClientUsername) this.creatorClientUsername = obj.CreatorClientUsername;
    }
}
